// extracted by mini-css-extract-plugin
export default {"multiListTable":"multi-list_multiListTable__3Jk1F","deleteColumn":"multi-list_deleteColumn__QwBia","deleteConfirmContainer":"multi-list_deleteConfirmContainer__a8781"};